<template>
  <dialogTem :visible.sync="dialogDown" 
  :diaTitle="$t('header.APPDownload')" :diaWidth="'328px'" :defaultTop="'12%'"
  >
    <div class="qr-box">
      <vue-qr
        class="codeQr"
        :margin="0"
        colorDark="#000"
        colorLight="#fff"
        :text="downloadData[0].url"
        :logoScale="0.2"
        :size="130"
      ></vue-qr>
    </div>
  </dialogTem>
</template>

<script>
import dialogTem from './dialogTem.vue'
import VueQr from "vue-qr";
import { mapState } from "vuex";
export default {
    components: { VueQr,dialogTem },
    data(){
        return{
            dialogDown:false
        }
    },
    computed:{
        downloadData() {
          return [{ url: this.appJump }];
        },
         ...mapState({
            appJump: (state) => state.linkList.appJump,
        }),
    }
}

</script>

<style lang="scss" scoped>
  .qr-box {
    padding-top:10px;
    padding-bottom:20px;
    width: 130px;
    height: 180px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    div{ border:10px solid #fff!important; }
  }
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/common/appDownload.vue